import { render, staticRenderFns } from "./videoPage.vue?vue&type=template&id=514caa12&scoped=true"
import script from "./videoPage.vue?vue&type=script&lang=js"
export * from "./videoPage.vue?vue&type=script&lang=js"
import style0 from "./videoPage.vue?vue&type=style&index=0&id=514caa12&prod&lang=css"
import style1 from "./videoPage.vue?vue&type=style&index=1&id=514caa12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514caa12",
  null
  
)

export default component.exports